import { render } from "./LearnMoreModal.vue?vue&type=template&id=a2219368&ts=true"
import script from "./LearnMoreModal.vue?vue&type=script&lang=ts"
export * from "./LearnMoreModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__